import api from '@pray/shared/utils/api';

import type { UpdateLeadSegmentResponse } from './data/response';
import type { LeadSegmentConditionGroup } from './transformers/types';

export type UpdateLeadSegmentParams = {
  artistId: string;
  segmentId: string;
  name?: string;
  description?: string;
  conditions?: LeadSegmentConditionGroup;
};

export async function updateLeadSegment({
  artistId,
  segmentId,
  name,
  description,
  conditions,
}: UpdateLeadSegmentParams) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!segmentId) throw new Error('Segment ID is required');
  if (!name && !description && !conditions) throw new Error('At least one field is required');

  const data = {
    name,
    description,
    conditions,
  };

  const url = `/web/studio/artists/${artistId}/lead-segments/${segmentId}`;
  const response = await api.executePutRequest<UpdateLeadSegmentResponse>(url, data);

  return response.data;
}
